<div class="card mb-3 border-0 shadow-sm">
  <div class="card-header bg-secondary text-white d-flex align-items-center gap-2">
    <i class="bx bx-line-chart bx-sm"></i>
    <strong>Observaciones</strong>
    <span class="badge bg-light text-dark ms-auto">{{ observations().length }}</span>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-sm table-bordered mb-0">
        <thead class="table-light">
          <tr>
            <th>Nombre</th>
            <th>Código</th>
            <th>Categoría</th>
            <th>Valor</th>
            <th>Fecha</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          @for (obs of observations(); track obs.id) {
            <tr>
              <td>{{ getObsName(obs) }}</td>
              <td>
                @if (getObsCode(obs)) {
                  <code class="small">{{ getObsCode(obs) }}</code>
                } @else {
                  <span class="text-muted">—</span>
                }
              </td>
              <td>
                @if (getCategory(obs)) {
                  <span class="badge bg-light text-dark border">{{ getCategory(obs) }}</span>
                } @else {
                  <span class="text-muted">—</span>
                }
              </td>
              <td>{{ getObsValue(obs) }}</td>
              <td>{{ formatDate(getEffectiveDate(obs)) }}</td>
              <td>
                @let badge = getStatusBadge(obs.status || '');
                <span class="badge {{ badge.color }}">{{ badge.label }}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
